import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import AddVehicle from './pages/AddVehicle';
import Customers from './pages/Customers';
import Deals from './pages/Deals';
import Import from './pages/Import';
import Feed from './pages/Feed';
import './App.css';

export default function App() {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('rz_user') || 'null'));
  const [token, setToken] = useState(() => localStorage.getItem('rz_token'));

  const login = (token, user) => {
    localStorage.setItem('rz_token', token);
    localStorage.setItem('rz_user', JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem('rz_token');
    localStorage.removeItem('rz_user');
    setToken(null);
    setUser(null);
  };

  if (!token || !user) return <Login onLogin={login} />;

  return (
    <BrowserRouter>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar user={user} onLogout={logout} />
        <div style={{ marginLeft: 220, flex: 1, padding: 28, background: '#0f0f0f', minHeight: '100vh' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/vehicles/add" element={<AddVehicle />} />
            <Route path="/vehicles/edit/:id" element={<AddVehicle />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/import" element={<Import />} />
            <Route path="/feed" element={<Feed user={user} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
